'use client';
import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from '../shop.module.css';

gsap.registerPlugin(ScrollTrigger);

export default function HeroBanner() {
  const heroTitleRef = useRef(null);

  useEffect(() => {
const ctx =  gsap.context(()=>{
    const layers = heroTitleRef.current.querySelectorAll('.text-layer');

    gsap.to(layers, {
      yPercent: (i) => {
        // Middle layer (index 4) stays at 0
        // Layers above go up, layers below go down
        const offset = i - 4;
        return offset * -3; // Reduced for tighter stacking
      },
      opacity: (i) => {
        // Fade out layers further from center
        const distance = Math.abs(i - 4);
        return 1 - (distance * 0.15); // Gradual fade
      },
      scrollTrigger: {
        trigger: `.${styles.heroBanner}`,
        start: 'top top',
        end: 'bottom top',
        scrub: 1,
      },
      ease: 'none'
    });
    })
    return ()=>ctx.revert()
  }, []);

  return (
    <div className={styles.heroBanner}>
      <div className={styles.heroContent}>
        <span className={styles.heroSubtitle}>Premium Quality</span>
        <p className={styles.heroDescription}>Science-backed supplements for optimal health</p>

        <div
          ref={heroTitleRef}
          className={styles.heroTitle}
          style={{
            fontWeight: 200,
            fontSize: "calc(15vw + 5rem)",
            position: "absolute",
            marginTop: 50,
            display: 'grid',
            placeItems: 'center'
          }}
        >
          {[...Array(9)].map((_, i) => (
            <span
              key={i}
              className="text-layer"
              style={{
                gridArea: '1 / 1',
                width:"fit-content",
                textAlign: "center",
                willChange: 'transform, opacity'
              }}
            >
              SHOP
            </span>
          ))}
        </div>
      </div>
      <div className={styles.heroGradient}></div>
    </div>
  );
}
